import { render, staticRenderFns } from "./TabsHeader.vue?vue&type=template&id=566bcece&scoped=true&"
import script from "./TabsHeader.vue?vue&type=script&lang=js&"
export * from "./TabsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabsHeader.vue?vue&type=style&index=0&id=566bcece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bcece",
  null
  
)

export default component.exports